import utils from '../../../../../components/Organisms/Form/utils'
import t from '../../../../../translations/main'

const config = utils.injectTranslation({
  id: 'WebsiteAccessForm',
  path: 'onboarding.forms.CorporateAccount.WebsiteAccessForm.inputs',
  keysToRemove: ['id'],
  content: [
    {
      componentType: 'grid',
      content: [
        {
          componentType: 'radioGroup',
          transformType: 'stringAndBooleanConversion',
          props: {
            name: 'accessToAccountActivity',
            minHeight: '0',
            dataList: [
              {
                id: 'accessToAccountActivity1',
                label: t('components.forms.labels.yes'),
                value: 'true',
              },
              {
                id: 'accessToAccountActivity2',
                label: t('components.forms.labels.no'),
                value: 'false',
              },
            ],
            required: true,
          },
        },
        {
          componentType: '',
          custom: () => null,
          props: {
            name: 'webSiteAccessContacts'
          }
        }
      ],
    },
  ],
})

export default config
